/***
 *
 *   CONTACT FORM PAGE
 *   Phase 10 — token pass.
 *
 **********/

import React from 'react';
import { ContactForm, Card } from 'components/lib';
import { useTranslate } from 'app/translations';

export function Contact(props) {
    const { _t } = useTranslate();

    return (
        <section className="py-16 md:py-24">
            <div className="mx-auto max-w-xl px-6">
                <h1 className="mb-8 text-2xl font-bold text-text-primary">{_t('contact.title')}</h1>
                <Card variant="elevated" last>
                    <ContactForm />
                </Card>
            </div>
        </section>
    );
}
